import React from "react";
import { Container } from "./styles";
import { RiMenuLine, RiCloseLine } from "react-icons/ri";

interface INavBtnProps {
  toggleMenu: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isMenuOpen: boolean;
}

const NavBtn = ({ toggleMenu, isMenuOpen }: INavBtnProps) => {
  return (
    <Container onClick={toggleMenu}>
      {isMenuOpen ? (
        <RiCloseLine size={28} color="var(--fixit)" />
      ) : (
        <RiMenuLine size={28} color="var(--dark-gray)" />
      )}
    </Container>
  )
}

export default NavBtn;
